module.exports = __webpack_public_path__ + "img/blue_facebook.eb5eb7bc.svg";